import { SAFEWORD_CHOICE_OPTIONS } from '@/pages/Onboarding/options/SafewordChoice/SAFEWORD_CHOICE_OPTIONS';
import { SafewordChoiceOptionIdType } from '@/pages/Onboarding/options/SafewordChoice/types';

const DEFAULT_ID: SafewordChoiceOptionIdType = 'little_control';
const DEFAULT_TITLE = SAFEWORD_CHOICE_OPTIONS[0].title;

export const getSafewordChoiceIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): SafewordChoiceOptionIdType | null => {
  const id = SAFEWORD_CHOICE_OPTIONS.find(
    (option) => option.title === title,
  )?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT_ID;
  }

  return null;
};

export const getSafewordChoiceTitleById = (
  id: SafewordChoiceOptionIdType | null | undefined,
  withDefault = false,
): string | null => {
  const title = SAFEWORD_CHOICE_OPTIONS.find(
    (option) => option.id === id,
  )?.title;

  if (title) {
    return title;
  }

  if (withDefault) {
    return DEFAULT_TITLE;
  }

  return null;
};
